import { render, staticRenderFns } from "./OES-suggest-score-modal.vue?vue&type=template&id=7c4aaa0d"
import script from "./OES-suggest-score-modal.vue?vue&type=script&lang=js"
export * from "./OES-suggest-score-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports